import { useContext, useState } from "react";
import { Alert, Box, Stack, Tab, Tabs, Paper } from "@mui/material";
// @ts-ignore
import { UserInfoContext } from "../contexts/UserInfoContext";
import OrganizationsPage from "./pages/organizations-page.tsx";
import TeamsPage from "./pages/teams-page.tsx";
import UsersPage from "./pages/users-page.tsx";

function AdminMain() {
  const { isEmployee } = useContext(UserInfoContext);
  const [activeTab, setActiveTab] = useState(0);

  if (!isEmployee()) {
    return <Alert severity="error" sx={{ m: 3, flex: 1, height: "fit-content" }}>You are not authorized to view this page.</Alert>;
  }

  return (
    <Stack sx={{ flex: 1, display: "flex", flexDirection: "column", height: "100%" }}>
      <Paper sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={activeTab} onChange={(_e, value) => setActiveTab(value)}>
          <Tab label="Organizations" />
          <Tab label="Teams" />
          <Tab label="Users" />
        </Tabs>
      </Paper>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto" }}>
        {activeTab === 0 && <OrganizationsPage />}
        {activeTab === 1 && <TeamsPage />}
        {activeTab === 2 && <UsersPage />}
      </Box>
    </Stack>
  );
}

export default AdminMain;
